import "./nexus-brand.css";

/** The interlocking N: two paths, one connected workspace. Cut from ice
 *  tones (Polar Night keeps hue for live state, the coach and the next
 *  action); the four facets are separated by tone. */
export function NexusMark({ className = "" }) {
  return (
    <svg
      className={`nexus-mark ${className}`}
      viewBox="0 0 44 44"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M5 34V10L12 6L31 25V10L39 6V34L32 38L13 19V30L5 34Z"
        className="nexus-mark__a"
      />
      <path
        d="M5 10L12 6L31 25V10L39 6L32 19V38L13 19V30L5 34V10Z"
        className="nexus-mark__b"
      />
      <path
        d="M5 10L13 14V30L5 34V10ZM31 25L39 34L32 38L13 19V14L31 32V25Z"
        className="nexus-mark__c"
      />
      <path d="M12 6L31 25V32L13 14L5 10L12 6Z" className="nexus-mark__d" />
    </svg>
  );
}

export default function NexusBrand({
  compact = false,
  className = "",
  size = "default",
}) {
  return (
    <span
      className={`nexus-brand nexus-brand--${size} ${className}`}
      aria-label="NexusDialer"
    >
      <NexusMark />
      {!compact && (
        <span className="nexus-brand__word" aria-hidden="true">
          nexus<span className="nexus-brand__descriptor">DIALER</span>
        </span>
      )}
    </span>
  );
}
